import { Component, OnInit } from '@angular/core';
import { BasicError } from '../../models/error/error';
import { User } from '../../models/user';

import { ProfileService } from '../../services/profile.service';
import { AuthenticationService } from '../../services/authentication.service';
declare var $: any;

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
  public currentUser: User = null;
  public updatedUser: User = null;

  // Vars for Visibility data
  public showName: Boolean = true;

  // Vars for Visibility from actions
  public isVisMyData: Boolean = true;
  public isVisMyDataEdit: Boolean = false;
  public isVisPassword: Boolean = false;

  // Vars for Update User
  public updateUserName: String = '';
  public updateFirstName: String = '';
  public updateLastName: String = '';
  public updateSex: String = '';
  public tmpUpdate: Object = {};

  // Vars for Update Password
  public newPassword: String = '';
  public newPasswordConf: String = '';

  // Vars for Status Codes
  public statusProfileSuccess: Boolean = false;
  public statusPasswordSuccess: Boolean = false;
  public statusPasswordUnsuccessLength: Boolean = false;
  public statusPasswordUnsuccessConf: Boolean = false;

  // Vars for Infos Output
  public outputInfo: String;
  public alertInfo: Boolean;

  public checkStatus: Boolean = false;
  public profilePicture: String;
  public profilePictureReady: Boolean = false;
  public profilePictureExtension: String = 'jpg';
  public fileTypes = ['jpg', 'jpeg', 'png', 'gif'];

  constructor(private profileService: ProfileService, private auth: AuthenticationService) { }

  ngOnInit() {
    this.profileService.getMyProfile().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Profile could not be read');
      } else if (data instanceof User) {
        this.currentUser = data;
        this.checkStatus = (this.currentUser.getSettings()) ? this.currentUser.getSettings()['visible'] : true;
        if (this.currentUser.getFirstName().length < 1) {
          this.showName = false;
        } else {
          this.showName = true;
        }
      }
    });
  }

  // Click 'Edit Profile'
  public navigateToMyDataEdit() {
    this.isVisMyDataEdit = true;
    this.isVisMyData = false;
    this.isVisPassword = false;
    this.statusPasswordSuccess = false;
    this.statusProfileSuccess = false;
  }

  // Click 'Edit Password'
  public navigateToPassword() {
    this.isVisMyDataEdit = false;
    this.isVisMyData = false;
    this.isVisPassword = true;
    this.statusProfileSuccess = false;
  }

  // Click 'Cancel'
  public navigateToMyData() {
    this.isVisMyDataEdit = false;
    this.isVisMyData = true;
    this.isVisPassword = false;
    this.statusPasswordUnsuccessConf = false;
    this.statusPasswordUnsuccessLength = false;
  }

  // Update attributes of User
  public updateNewAttributes() {
    this.updatedUser = new User(null);

    if (this.updateUserName === '') { this.updateUserName = this.currentUser.getName(); }
    this.updatedUser.setName(this.updateUserName);

    if (this.updateFirstName === '') { this.updateFirstName = this.currentUser.getFirstName(); }
    this.updatedUser.setFirstName(this.updateFirstName);

    if (this.updateLastName === '') { this.updateLastName = this.currentUser.getLastName(); }
    this.updatedUser.setLastName(this.updateLastName);

    if (this.updateSex === '') {
      this.updateSex = this.currentUser.getSex();
    } else {
      this.updatedUser.setSex(this.updateSex);
    }

    if (this.currentUser.getSettings() === null || this.currentUser.getSettings() === undefined) {
      if (this.checkStatus) {
        this.updatedUser.setSettings({ 'visible': true });
      } else {
        this.updatedUser.setSettings({ 'visible': false });
      }
    } else {
      if (this.checkStatus) {
        this.tmpUpdate = {};
        this.tmpUpdate['visible'] = true;
        this.updatedUser.setSettings(this.tmpUpdate);
      } else {
        this.tmpUpdate = {};
        this.tmpUpdate['visible'] = false;
        this.updatedUser.setSettings(this.tmpUpdate);
      }
    }

    if (this.profilePicture === '' || this.profilePicture === undefined) { this.profilePicture = this.currentUser.getPicture() }
    this.updatedUser.setPicture(this.profilePicture);


    this.profileService.updateMyProfile(this.currentUser, this.updatedUser).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Profile could not be updated');
        console.log(data);
      } else {
        this.profileService.getMyProfile(true);
        this.isVisMyDataEdit = false;
        this.isVisMyData = true;
        this.statusProfileSuccess = true;

        // Refresh data
        window.location.reload();
      }
    });

  }

  // Update password of User
  public updateNewPassword() {
    this.updatedUser = new User(null);

    if (this.newPassword !== '' && this.newPasswordConf !== '' && this.newPassword === this.newPasswordConf &&
      this.newPassword.length >= 8) {
      this.profileService.updateMyPassword(this.newPassword, this.newPasswordConf).subscribe(data => {
        if (!data) {
          console.log('Password could not be updated');
          console.log(data);
        } else {
          this.profileService.getMyProfile(true);
          this.isVisPassword = false;
          this.isVisMyData = true;
          this.statusPasswordSuccess = true;
          this.statusPasswordUnsuccessConf = false;
          this.statusPasswordUnsuccessLength = false;
        }
      });
    } else {
      if (this.newPassword !== this.newPasswordConf) {
        this.statusPasswordUnsuccessConf = true;

      } else if (this.newPassword.length < 8) {
        this.statusPasswordUnsuccessLength = true;
      }
    }
  }


  public uploadPicture() {
    this.updatedUser = new User(null);

    if (this.updateUserName === '') { this.updateUserName = this.currentUser.getName(); }
    this.updatedUser.setName(this.updateUserName);

    if (this.updateFirstName === '') { this.updateFirstName = this.currentUser.getFirstName(); }
    this.updatedUser.setFirstName(this.updateFirstName);

    if (this.updateLastName === '') { this.updateLastName = this.currentUser.getLastName(); }
    this.updatedUser.setLastName(this.updateLastName);

    if (this.updateSex === '') {
      this.updateSex = this.currentUser.getSex();
    } else {
      this.updatedUser.setSex(this.updateSex);
    }

    if (this.currentUser.getSettings() === null || this.currentUser.getSettings() === undefined) {
      if (this.checkStatus) {
        this.updatedUser.setSettings({ 'visible': true });
      } else {
        this.updatedUser.setSettings({ 'visible': false });
      }
    } else {
      if (this.checkStatus) {
        this.tmpUpdate = {};
        this.tmpUpdate['visible'] = true;
        this.updatedUser.setSettings(this.tmpUpdate);
      } else {
        this.tmpUpdate = {};
        this.tmpUpdate['visible'] = false;
        this.updatedUser.setSettings(this.tmpUpdate);
      }
    }

    this.updatedUser.setPicture(this.profilePicture);

    this.profileService.updateMyProfile(this.currentUser, this.updatedUser, this.profilePictureExtension.toString()).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Picture could not be updated');
        console.log(data);
      } else {
        this.profileService.getMyProfile(true);

        // Refresh data
        window.location.reload();
      }
    });
  }


  public readURL(id) {
    const input = $('#' + id).get(0);

    if (input.files && input.files[0]) {
      const extension = input.files[0].name.split('.').pop().toLowerCase();  // file extension from input file
      const isSuccess = this.fileTypes.indexOf(extension) > -1; // check if file extension is correct

      if (!isSuccess) {
        return;
      }

      this.profilePictureExtension = extension;

      const reader = new FileReader();

      const ctrl = this;
      reader.addEventListener('load', function () {
        ctrl.profilePicture = reader.result;
        ctrl.profilePictureReady = true;
      }, false);

      reader.readAsDataURL(input.files[0]);

    }
  }

  // Delete Profile
  public deleteProfile() {
    this.profileService.deleteMyProfile().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Delete Profile failed!');
        console.log(data);
      } else {
        this.logout();
      }
    });
  }

  public logout() {
    this.auth.logout();
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-profile/my-profile.component.ts